import { Injectable } from "@angular/core";
import { MsalService, MsalBroadcastService } from "@azure/msal-angular";
import { Store } from "@ngrx/store";
import {
  EventMessage,
  EventType,
  InteractionStatus,
} from "@azure/msal-browser";
import { GetPadlockTokenFromB2CToken } from "../padlock/state/padlock-token.actions";
import { filter } from "rxjs/operators";
import { NGXLogger } from "ngx-logger";

@Injectable({ providedIn: "root" })
export class B2cService {
  logoutRedirectRequest = {};

  constructor(
    private store: Store<any>,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private logger: NGXLogger,
  ) {}

  signIn(idpParam: string) {
    const request = {
      scopes: [],
      extraQueryParameters: { domain_hint: idpParam },
    };
    this.msalService.instance.loginRedirect(request);
  }

  initMsal(): void {
    const msalInstance = this.msalService.instance;
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None,
        ),
      )
      .subscribe(() => {
        const alreadyLoggedIn = msalInstance.getAllAccounts().length > 0;
        this.logger.info(`Azure B2C Already Logged in`, alreadyLoggedIn);
      });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.LOGIN_SUCCESS ||
            msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS,
        ),
      )
      .subscribe((result: EventMessage) => {
        this.logger.info(`Azure B2C Login Success`);
        const account = result.payload["account"];
        const idToken = result.payload["idToken"];

        msalInstance.setActiveAccount(account);
        this.logger.info(`B2C Account`, msalInstance.getActiveAccount());
        setTimeout(() => {
          this.store.dispatch(new GetPadlockTokenFromB2CToken(idToken));
        }, 1000);
      });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE,
        ),
      )
      .subscribe(() => {
        this.logger.info(`Azure B2C Login Fail`);
      });
  }

  logoutB2C() {
    this.msalService.instance.logoutRedirect(this.logoutRedirectRequest);
    this.removeB2cRedirect();
  }

  startB2cLogin(idpParam: string, b2cRedirect: string) {
    sessionStorage.setItem("b2cRedirect", b2cRedirect);
    this.signIn(idpParam);
  }

  getB2cRedirect() {
    return sessionStorage.getItem("b2cRedirect");
  }

  removeB2cRedirect() {
    sessionStorage.removeItem("b2cRedirect");
  }
}
